import type React from "react";

/**
 * Enter and Space on an element that behaves like a button but is not one.
 *
 * The package has no `ListItemButton` yet, so several rows on the contact
 * detail are an `Inline` carrying an `onClick`. A row wired to the mouse alone
 * cannot be reached by keyboard at all, so each pairs `role="button"` and
 * `tabIndex={0}` with this. Delete it when those rows become real buttons.
 */
export const activateOnKey =
  (activate: () => void) =>
  (event: React.KeyboardEvent): void => {
    if (event.key !== "Enter" && event.key !== " ") return;
    // Space scrolls the page and Enter can submit an enclosing form.
    event.preventDefault();
    activate();
  };
